import uniq from 'lodash/uniq';

export default function mergeDataSyncObjects(dataSyncObjects) {
  if (!dataSyncObjects || dataSyncObjects.length < 1) {
    return {};
  }
  const mergedObject = dataSyncObjects.reduce((acc, obj) => ({
    ...acc,
    commands: [...acc.commands, ...obj.commands],
    events: [...acc.events, ...obj.events],
    enrollmentIds: uniq([...acc.enrollmentIds, ...obj.enrollmentIds]),
    stateIds: uniq([...acc.stateIds, ...obj.stateIds]),
    stateInteractionIds: uniq([...acc.stateInteractionIds, ...obj.stateInteractionIds]),
    timeStamp: new Date().toISOString()
  }));
  return mergedObject;
}
